// import "./App.css";
// import Card from "react-bootstrap/Card";
// import Logo from "./assets/logo.png";

// // import Search from "./assets/Vector.png";
// import axios from "axios";
// import Hero from "./assets/herosection.png";
// import { useEffect, useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
// import {
//   Button,
//   Col,
//   Container,
//   Form,
//   Nav,
//   NavLink,
//   Navbar,
//   Row,
// } from "react-bootstrap";

// import "bootstrap/dist/css/bootstrap.min.css";

// function App() {
//   const [showSubCards, setShowSubCards] = useState(false);
//   const [subCardData, setSubCardsData] = useState([]);
//   const [cards, setCards] = useState([]);

//   const [courses, setCourses] = useState([]);
//   const [algs, setAlgs] = useState([]);
//   const [coordinators, setCoordinators] = useState([]);
//   const [resources, setResources] = useState([]);
//   const [permSchedules, setPermSchedules] = useState([]);
//   const [courseRelatedData, setCourseRelatedData] = useState();

//   const [finalizedCardsContent, setFinalizedCardsContent] = useState([]);
//   // console.log("cards is", cards);

//   const [hideMainContent, setHideMainContent] = useState(false);

//   const requiredCourses = [1114, 3003, 3123, 3203, 3223, 3423, 3883, 4323, 4683, 4723, 4823, 4983];
//   const dataAnalysticsAndTechnology = [3703, 4713, 4733, 4773, 4793];
//   const cyberOperationsAndSecurity = [4833, 4843, 4853, 4863, 4883, 4893];
//   const enterpriseSystems = [3503, 4153, 4403, 4333, 4673];
//   const technologyAndInnovation = [4603, 4613, 4623, 4633];

//   useEffect(() => {
//     axios
//       .get(
//         "https://lgl8fzfq6i.execute-api.ap-south-1.amazonaws.com/dev/courses"
//       )
//       .then((response) => {
//         // console.log("Course data==>:", response);

//         setCards([...response?.data.courses]);
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//       });
//   }, []);
//   useEffect(() => {
//     axios
//       .get(
//         "https://lgl8fzfq6i.execute-api.ap-south-1.amazonaws.com/dev/courses"
//       )
//       .then((response) => {
//         // console.log("Resource data==>:", response);

//         setCourses([...response?.data.courses]);
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//       });
//   }, []);
//   useEffect(() => {
//     axios
//       .get(
//         "https://lgl8fzfq6i.execute-api.ap-south-1.amazonaws.com/dev/resources"
//       )
//       .then((response) => {
//         // console.log("Resource data==>:", response);

//         setResources([...response?.data.courses]);
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//       });
//   }, []);
//   useEffect(() => {
//     axios
//       .get(
//         "https://lgl8fzfq6i.execute-api.ap-south-1.amazonaws.com/dev/coordinator"
//       )
//       .then((response) => {
//         // console.log("Resource data==>:", response);

//         setCoordinators([...response?.data.courses]);
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//       });
//   }, []);
//   useEffect(() => {
//     axios
//       .get(
//         "https://lgl8fzfq6i.execute-api.ap-south-1.amazonaws.com/dev/alg"
//       )
//       .then((response) => {
//         // console.log("Resource data==>:", response);

//         setAlgs([...response?.data.courses]);
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//       });
//   }, []);
//   useEffect(() => {
//     axios
//       .get(
//         "https://lgl8fzfq6i.execute-api.ap-south-1.amazonaws.com/dev/permSchedules"
//       )
//       .then((response) => {
//         // console.log("Resource data==>:", response);

//         setPermSchedules([...response?.data.courses]);
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//       });
//   }, []);

//   // useEffect(() => {
//   //   // console.log("Cards data from modifiedData block : ", cards);
//   //   // console.log("Courses data from modifiedData block : ", courses);
//   //   // console.log("Resources data from modifiedData block : ", resources);
//   //   // console.log("Algs data from modifiedData block : ", algs);
//   //   // console.log("Coordinators data from modifiedData block : ", coordinators);
//   //   // console.log("PermSchedules data from modifiedData block : ", permSchedules);
//   //   const modifiedData = courses?.map((item) => ({
//   //     ...item,
//   //     subCardData: [
//   //       {
//   //         name: "",
//   //         description: "",
//   //       },
//   //     ],
//   //     resource: resources.find(o => o.courseNumber === item.courseNumber),
//   //     alg: algs.find(o => o.courseNumber === item.courseNumber),
//   //     coordinator: coordinators.find(o => o.courseNumber === item.courseNumber),
//   //     permSchedule: permSchedules.find(o => o.courseNumber === item.courseNumber)
//   //   }));
//   //   console.log("modifiedData==>", modifiedData);
//   //   // setCards([...response?.data]);
//   //   const filteredData = modifiedData.filter(item => requiredCourses.includes(item.courseNumber));
//   //   setFinalizedCardsContent([...filteredData]);
//   // }, [courses]);

//   const _redirectToSelectedContent = (id) => {
//     console.log("Selected Id: ", id);
//     const modifiedData = courses?.map((item) => ({
//       ...item,
//       subCardData: [
//         {
//           name: "",
//           description: "",
//         },
//       ],
//       resource: resources.find(o => o.courseNumber === item.courseNumber),
//       alg: algs.find(o => o.courseNumber === item.courseNumber),
//       coordinator: coordinators.find(o => o.courseNumber === item.courseNumber),
//       permSchedule: permSchedules.find(o => o.courseNumber === item.courseNumber)
//     }));
//     console.log("modifiedData==>", modifiedData);
//     // setCards([...response?.data]);
//     let filteredData = [];
//     if (id == "1")
//       filteredData = modifiedData.filter(item => requiredCourses.includes(item.courseNumber));
//     if (id == "2")
//       filteredData = modifiedData.filter(item => dataAnalysticsAndTechnology.includes(item.courseNumber));
//     if (id == "3")
//       filteredData = modifiedData.filter(item => cyberOperationsAndSecurity.includes(item.courseNumber));
//     if (id == "4")
//       filteredData = modifiedData.filter(item => enterpriseSystems.includes(item.courseNumber));
//     if (id == "5")
//       filteredData = modifiedData.filter(item => technologyAndInnovation.includes(item.courseNumber));
//     filteredData.sort((a, b) => a.courseNumber - b.courseNumber);
//     setFinalizedCardsContent([...filteredData]);
//     setHideMainContent(true);
//   };

//   const _goBackMainContent = () => {
//     setHideMainContent(false);
//   };

//   return (
//     <div className="App" style={{ paddingHorizontal: 25 }}>
//       <header className="App-header">
//         <div
//           style={{
//             height: 73,
//             width: "100%",
//             backgroundColor: "#202020",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           <img src={Logo} alt="" style={{ height: 73, width: 301 }} />
//           {/* <Form className="d-flex">
//             <Form.Control
//               type="search"
//               placeholder="Search"
//               className="me-2"
//               aria-label="Search"
//             />
//           </Form> */}
//         </div>
//         <div></div>
//         <Navbar expand="lg" className="bg-body-tertiary">
//           <Container
//             fluid
//           // style={{ marginLeft: 350, justifyContent: "space-evenly" }}
//           >
//             {/* <Navbar.Brand href="#">Navbar scroll</Navbar.Brand> */}
//             <Navbar.Toggle aria-controls="navbarScroll" />
//             <Navbar.Collapse id="navbarScroll">
//               <Nav
//                 className="me-auto my-2 mx-5  my-lg-0"
//                 style={{
//                   maxHeight: "100px",
//                   width: "100%",
//                   justifyContent: "space-between",
//                   // alignContent: "space-between",
//                 }}
//                 navbarScroll
//               >
//                 <Nav.Link href="#action1">Home</Nav.Link>
//                 <Nav.Link href="#action2">Courses</Nav.Link>
//                 <Nav.Link href="#action1">Resources</Nav.Link>
//                 <Nav.Link href="#action2">ALG</Nav.Link>
//                 <Nav.Link href="#action2">Co-Ordinators</Nav.Link>
//                 <Nav.Link href="#action2">Perm Schedules</Nav.Link>
//               </Nav>
//             </Navbar.Collapse>
//           </Container>
//         </Navbar>
//       </header>
//       <div style={{ width: "100%" }}>
//         {/* <img src={Hero} alt="" style={{ height: 600, width: "100%" }} /> */}
//       </div>
//       <div
//         style={{
//           flexDirection: "row",
//           display: "flex",
//           flexWrap: "wrap",
//           justifyContent: "center",
//           // gap: 50
//           marginTop: 42,
//         }}
//       >
//         {

//           !hideMainContent ? (<>
//             <Card style={{ width: '14rem' }}>
//               <Card.Img variant="top" src={Logo} />
//               <Card.Body>
//                 <Card.Title>Required Major Courses</Card.Title>
//                 <Card.Text>

//                 </Card.Text>
//                 {/* <Button variant="primary">Go somewhere</Button> */}
//               </Card.Body>
//               <Card.Footer><Button variant="warning" onClick={() => _redirectToSelectedContent(1)}>Click Here</Button></Card.Footer>
//             </Card>
//             <Card style={{ width: '14rem', marginLeft: "1rem" }}>
//               <Card.Img variant="top" src={Logo} />
//               <Card.Body>
//                 <Card.Title>Data Analytics and Technology</Card.Title>
//                 <Card.Text>

//                 </Card.Text>
//                 {/* <Button variant="primary">Go somewhere</Button> */}
//               </Card.Body>
//               <Card.Footer><Button variant="warning" onClick={() => _redirectToSelectedContent(2)}>Click Here</Button></Card.Footer>
//             </Card>
//             <Card style={{ width: '14rem', marginLeft: "1rem" }}>
//               <Card.Img variant="top" src={Logo} />
//               <Card.Body>
//                 <Card.Title>Cyber Operations Security</Card.Title>
//                 <Card.Text>

//                 </Card.Text>
//                 {/* <Button variant="primary">Go somewhere</Button> */}
//               </Card.Body>
//               <Card.Footer><Button variant="warning" onClick={() => _redirectToSelectedContent(3)}>Click Here</Button></Card.Footer>
//             </Card>
//             <Card style={{ width: '14rem', marginLeft: "1rem" }}>
//               <Card.Img variant="top" src={Logo} />
//               <Card.Body>
//                 <Card.Title>Enterprise Systems</Card.Title>
//                 <Card.Text>

//                 </Card.Text>
//                 {/* <Button variant="primary">Go somewhere</Button> */}
//               </Card.Body>
//               <Card.Footer><Button variant="warning" onClick={() => _redirectToSelectedContent(4)}>Click Here</Button></Card.Footer>
//             </Card>
//             <Card style={{ width: '14rem', marginLeft: "1rem" }}>
//               <Card.Img variant="top" src={Logo} />
//               <Card.Body>
//                 <Card.Title>Technology and Innovation</Card.Title>
//                 <Card.Text>

//                 </Card.Text>
//                 {/* <Button variant="primary">Go somewhere</Button> */}
//               </Card.Body>
//               <Card.Footer><Button variant="warning" onClick={() => _redirectToSelectedContent(5)}>Click Here</Button></Card.Footer>
//             </Card>
//           </>
//           ) : (
//             !showSubCards ? (
//               finalizedCardsContent?.map((course, index) => {
//                 return (
//                   <div
//                     key={index}
//                     style={{
//                       padding: 10,
//                       gap: 50,
//                       width: "33%",
//                       // backgroundColor: "red",
//                       color: "black",
//                       // boxShadow: "10px black",
//                     }}
//                   >
//                     <Card>
//                       <Card.Body
//                         style={{
//                           height: "350px",
//                         }}
//                       >
//                         <Card.Title>
//                           <p
//                             style={{
//                               fontFamily: "Poppins",
//                               fontSize: 24,

//                               fontStyle: "normal",
//                               fontWeight: 600,
//                               lineHeight: "110%",
//                             }}
//                           >
//                             {course?.courseName}
//                           </p>
//                         </Card.Title>
//                         <Card.Subtitle className="mb-2 text-muted">
//                           <p
//                             style={{
//                               fontFamily: "Poppins",
//                               fontSize: 16,
//                               fontStyle: "normal",
//                               fontWeight: 600,
//                               lineHeight: "110%",
//                             }}
//                           >
//                             {course?.courseNumber}
//                           </p>
//                         </Card.Subtitle>
//                         <Card.Text>{course?.description}</Card.Text>
//                       </Card.Body>
//                       <Card.Footer style={{ textAlign: "end" }}>
//                         <Button
//                           size="sm"
//                           style={{ backgroundColor: "none" }}
//                           variant="warning"
//                           onClick={() => {
//                             setShowSubCards(true);
//                             setSubCardsData(course?.subCardData);
//                             setCourseRelatedData(course);
//                           }}
//                         >
//                           <FontAwesomeIcon
//                             icon={faArrowRight}
//                             size="2x"
//                             style={{ width: "40px" }}
//                           />
//                         </Button>
//                       </Card.Footer>
//                     </Card>
//                   </div>
//                 );
//               })) : (
//               <>
//                 <Button
//                   size="sm"
//                   variant="warning"
//                   style={{ backgroundColor: "none" }}
//                   onClick={() => {
//                     setShowSubCards(false);
//                   }}
//                 >
//                   <FontAwesomeIcon
//                     icon={faArrowLeft}
//                     size="2x"
//                     style={{ width: "40px" }}
//                   />
//                 </Button>
//                 {subCardData?.map((item, index) => {
//                   return (
//                     <div
//                       key={index}
//                       style={{
//                         padding: 10,
//                         gap: 50,
//                         width: "90%",
//                         // backgroundColor: "red",
//                         color: "black",
//                         // boxShadow: "10px black",
//                       }}
//                     >
//                       <Card style={{ marginBottom: "1rem" }}>
//                         <Card.Body
//                           style={{
//                             height: "200px",
//                           }}
//                         >
//                           <Card.Title>
//                             <p
//                               style={{
//                                 fontFamily: "Poppins",
//                                 fontSize: 24,
//                                 fontStyle: "normal",
//                                 fontWeight: 600,
//                                 lineHeight: "110%",
//                               }}
//                             >
//                               Alg
//                             </p>
//                           </Card.Title>
//                           <Card.Subtitle className="mb-2 text-muted">
//                             <p
//                               style={{
//                                 fontFamily: "Poppins",
//                                 fontSize: 16,
//                                 fontStyle: "normal",
//                                 fontWeight: 600,
//                                 lineHeight: "110%",
//                               }}
//                             >
//                               {item?.alg?.algEligible}
//                             </p>
//                           </Card.Subtitle>
//                           <Card.Text>{"History Round And Developers : " + item?.alg?.historyRoundAndDevelopers}</Card.Text>
//                         </Card.Body>
//                       </Card>
//                       <Card style={{ marginBottom: "1rem" }}>
//                         <Card.Body
//                           style={{
//                             height: "200px",
//                           }}
//                         >
//                           <Card.Title>
//                             <p
//                               style={{
//                                 fontFamily: "Poppins",
//                                 fontSize: 24,

//                                 fontStyle: "normal",
//                                 fontWeight: 600,
//                                 lineHeight: "110%",
//                               }}
//                             >
//                               Coordinator
//                             </p>
//                           </Card.Title>
//                           <Card.Subtitle className="mb-2 text-muted">
//                             <p
//                               style={{
//                                 fontFamily: "Poppins",
//                                 fontSize: 16,
//                                 fontStyle: "normal",
//                                 fontWeight: 600,
//                                 lineHeight: "110%",
//                               }}
//                             >
//                               {courseRelatedData?.coordinator?.firstName + " " + courseRelatedData?.coordinator?.lastName}
//                             </p>
//                           </Card.Subtitle>
//                           <Card.Text>{courseRelatedData?.coordinator?.email + " " + courseRelatedData?.coordinator?.d2lMasterLink}</Card.Text>
//                         </Card.Body>
//                       </Card>
//                       <Card style={{ marginBottom: "1rem" }}>
//                         <Card.Body
//                           style={{
//                             height: "200px",
//                           }}
//                         >
//                           <Card.Title>
//                             <p
//                               style={{
//                                 fontFamily: "Poppins",
//                                 fontSize: 24,

//                                 fontStyle: "normal",
//                                 fontWeight: 600,
//                                 lineHeight: "110%",
//                               }}
//                             >
//                               Resources
//                             </p>
//                           </Card.Title>
//                           <Card.Subtitle className="mb-2 text-muted">
//                             <p
//                               style={{
//                                 fontFamily: "Poppins",
//                                 fontSize: 16,
//                                 fontStyle: "normal",
//                                 fontWeight: 600,
//                                 lineHeight: "110%",
//                               }}
//                             >
//                               {courseRelatedData?.resource?.courseCatalog}
//                             </p>
//                           </Card.Subtitle>
//                           <Card.Text>{"Learning outcomes : " + courseRelatedData?.resource?.learningOutcomes}</Card.Text>
//                         </Card.Body>
//                       </Card>
//                       <Card>
//                         <Card.Body
//                           style={{
//                             height: "200px",
//                           }}
//                         >
//                           <Card.Title>
//                             <p
//                               style={{
//                                 fontFamily: "Poppins",
//                                 fontSize: 24,

//                                 fontStyle: "normal",
//                                 fontWeight: 600,
//                                 lineHeight: "110%",
//                               }}
//                             >
//                               Offering History
//                             </p>
//                           </Card.Title>
//                           <Card.Subtitle className="mb-2 text-muted">
//                             <p
//                               style={{
//                                 fontFamily: "Poppins",
//                                 fontSize: 16,
//                                 fontStyle: "normal",
//                                 fontWeight: 600,
//                                 lineHeight: "110%",
//                               }}
//                             >
//                               Perm Schedule
//                             </p>
//                           </Card.Subtitle>
//                           <Card.Text>{courseRelatedData?.permSchedule?.coursePrefix + "" + courseRelatedData?.permSchedule?.courseNumber}</Card.Text>
//                         </Card.Body>
//                       </Card>
//                     </div>
//                   );
//                 })}
//               </>
//             )
//           )

//           // showSubCards ? (
//           //   <>
//           //     <Button
//           //       style={{ backgroundColor: "none" }}
//           //       onClick={() => {
//           //         setShowSubCards(false);
//           //       }}
//           //     >
//           //       <FontAwesomeIcon
//           //         icon={faArrowLeft}
//           //         size="2x"
//           //         style={{ width: "40px" }}
//           //       />
//           //     </Button>
//           //     {subCardData?.map((item, index) => {
//           //       return (
//           //         <div
//           //           key={index}
//           //           style={{
//           //             padding: 10,
//           //             gap: 50,
//           //             width: "90%",
//           //             // backgroundColor: "red",
//           //             color: "black",
//           //             // boxShadow: "10px black",
//           //           }}
//           //         >
//           //           <Card>
//           //             <Card.Body
//           //               style={{
//           //                 height: "200px",
//           //               }}
//           //             >
//           //               <Card.Title>
//           //                 <p
//           //                   style={{
//           //                     fontFamily: "Poppins",
//           //                     fontSize: 24,

//           //                     fontStyle: "normal",
//           //                     fontWeight: 600,
//           //                     lineHeight: "110%",
//           //                   }}
//           //                 >
//           //                   Alg
//           //                 </p>
//           //               </Card.Title>
//           //               <Card.Subtitle className="mb-2 text-muted">
//           //                 <p
//           //                   style={{
//           //                     fontFamily: "Poppins",
//           //                     fontSize: 16,
//           //                     fontStyle: "normal",
//           //                     fontWeight: 600,
//           //                     lineHeight: "110%",
//           //                   }}
//           //                 >
//           //                   {item?.alg?.algEligible}
//           //                 </p>
//           //               </Card.Subtitle>
//           //               <Card.Text>{"History Round And Developers : " + item?.alg?.historyRoundAndDevelopers}</Card.Text>
//           //             </Card.Body>
//           //           </Card>
//           //           <Card>
//           //             <Card.Body
//           //               style={{
//           //                 height: "200px",
//           //               }}
//           //             >
//           //               <Card.Title>
//           //                 <p
//           //                   style={{
//           //                     fontFamily: "Poppins",
//           //                     fontSize: 24,

//           //                     fontStyle: "normal",
//           //                     fontWeight: 600,
//           //                     lineHeight: "110%",
//           //                   }}
//           //                 >
//           //                   Coordinator
//           //                 </p>
//           //               </Card.Title>
//           //               <Card.Subtitle className="mb-2 text-muted">
//           //                 <p
//           //                   style={{
//           //                     fontFamily: "Poppins",
//           //                     fontSize: 16,
//           //                     fontStyle: "normal",
//           //                     fontWeight: 600,
//           //                     lineHeight: "110%",
//           //                   }}
//           //                 >
//           //                   {courseRelatedData?.coordinator?.firstName + " " + courseRelatedData?.coordinator?.lastName}
//           //                 </p>
//           //               </Card.Subtitle>
//           //               <Card.Text>{courseRelatedData?.coordinator?.email + " " + courseRelatedData?.coordinator?.d2lMasterLink}</Card.Text>
//           //             </Card.Body>
//           //           </Card>
//           //           <Card>
//           //             <Card.Body
//           //               style={{
//           //                 height: "200px",
//           //               }}
//           //             >
//           //               <Card.Title>
//           //                 <p
//           //                   style={{
//           //                     fontFamily: "Poppins",
//           //                     fontSize: 24,

//           //                     fontStyle: "normal",
//           //                     fontWeight: 600,
//           //                     lineHeight: "110%",
//           //                   }}
//           //                 >
//           //                   Resources
//           //                 </p>
//           //               </Card.Title>
//           //               <Card.Subtitle className="mb-2 text-muted">
//           //                 <p
//           //                   style={{
//           //                     fontFamily: "Poppins",
//           //                     fontSize: 16,
//           //                     fontStyle: "normal",
//           //                     fontWeight: 600,
//           //                     lineHeight: "110%",
//           //                   }}
//           //                 >
//           //                   {courseRelatedData?.resource?.courseCatalog}
//           //                 </p>
//           //               </Card.Subtitle>
//           //               <Card.Text>{"Learning outcomes : " + courseRelatedData?.resource?.learningOutcomes}</Card.Text>
//           //             </Card.Body>
//           //           </Card>
//           //           <Card>
//           //             <Card.Body
//           //               style={{
//           //                 height: "200px",
//           //               }}
//           //             >
//           //               <Card.Title>
//           //                 <p
//           //                   style={{
//           //                     fontFamily: "Poppins",
//           //                     fontSize: 24,

//           //                     fontStyle: "normal",
//           //                     fontWeight: 600,
//           //                     lineHeight: "110%",
//           //                   }}
//           //                 >
//           //                   Offering History
//           //                 </p>
//           //               </Card.Title>
//           //               <Card.Subtitle className="mb-2 text-muted">
//           //                 <p
//           //                   style={{
//           //                     fontFamily: "Poppins",
//           //                     fontSize: 16,
//           //                     fontStyle: "normal",
//           //                     fontWeight: 600,
//           //                     lineHeight: "110%",
//           //                   }}
//           //                 >
//           //                   Perm Schedule
//           //                 </p>
//           //               </Card.Subtitle>
//           //               <Card.Text>{courseRelatedData?.permSchedule?.coursePrefix + "" + courseRelatedData?.permSchedule?.courseNumber}</Card.Text>
//           //             </Card.Body>
//           //           </Card>
//           //         </div>
//           //       );
//           //     })}
//           //   </>
//           // ) : (
//           //   finalizedCardsContent?.map((course, index) => {
//           //     return (
//           //       <div
//           //         key={index}
//           //         style={{
//           //           padding: 10,
//           //           gap: 50,
//           //           width: "33%",
//           //           // backgroundColor: "red",
//           //           color: "black",
//           //           // boxShadow: "10px black",
//           //         }}
//           //       >
//           //         <Card>
//           //           <Card.Body
//           //             style={{
//           //               height: "350px",
//           //             }}
//           //           >
//           //             <Card.Title>
//           //               <p
//           //                 style={{
//           //                   fontFamily: "Poppins",
//           //                   fontSize: 24,

//           //                   fontStyle: "normal",
//           //                   fontWeight: 600,
//           //                   lineHeight: "110%",
//           //                 }}
//           //               >
//           //                 {course?.courseName}
//           //               </p>
//           //             </Card.Title>
//           //             <Card.Subtitle className="mb-2 text-muted">
//           //               <p
//           //                 style={{
//           //                   fontFamily: "Poppins",
//           //                   fontSize: 16,
//           //                   fontStyle: "normal",
//           //                   fontWeight: 600,
//           //                   lineHeight: "110%",
//           //                 }}
//           //               >
//           //                 {course?.courseNumber}
//           //               </p>
//           //             </Card.Subtitle>
//           //             <Card.Text>{course?.description}</Card.Text>
//           //           </Card.Body>
//           //           <Button
//           //             style={{ backgroundColor: "none" }}
//           //             onClick={() => {
//           //               setShowSubCards(true);
//           //               setSubCardsData(course?.subCardData);
//           //               setCourseRelatedData(course);
//           //             }}
//           //           >
//           //             <FontAwesomeIcon
//           //               icon={faArrowRight}
//           //               size="2x"
//           //               style={{ width: "40px" }}
//           //             />
//           //           </Button>
//           //         </Card>
//           //       </div>
//           //     );
//           //   })
//           // )


//         }
//       </div>

//       <div>
//         {
//           (hideMainContent && !showSubCards) ? (
//             <>
//               <div
//                 style={{
//                   flexDirection: "row",
//                   display: "flex",
//                   flexWrap: "wrap",
//                   justifyContent: "center",
//                   marginTop: 20
//                 }}>
//                 <Button variant="warning" size="sm" onClick={_goBackMainContent}>
//                   Go Back
//                 </Button>
//               </div>
//             </>
//           ) : (
//             <></>
//           )
//         }
//       </div>

//       <div>
//         <footer className="bg-dark text-light py-3" style={{ marginTop: "1rem" }}>
//           <div className="container">
//             <div className="row">
//               <div className="col-md-2">
//                 <h5 style={{ color: "#FEBC11" }}>Contact Info</h5>
//                 <p>Kennesaw Campus 1000 Chastain Road Kennesaw, GA 30144.</p>
//                 <p>
//                   Marietta Campus 1100 South Marietta PkwyMarietta, GA 30060
//                 </p>
//                 <p>Phone 470-KSU-INFO (470-578-4636)</p>
//               </div>
//               <div className="col-md-2">
//                 <h5 style={{ color: "#FEBC11" }}>Resources For</h5>
//                 <p>Current Students</p>
//                 <p> Online Only Students</p>
//                 <p>Faculty & Staff</p>
//                 <p> Family Alumni & Friends Community</p>
//                 {/* <p>Current Students</p> */}
//               </div>
//               <div className="col-md-2">
//                 <h5 style={{ color: "#FEBC11" }}>Related Links</h5>
//                 <p>Libraries </p>
//                 <p>Housing </p>
//                 <p>Financial Aid </p>
//                 <p>Degrees, Majors & Programs </p>
//                 <p>Register </p>
//                 <p>job oppurtunity</p>
//               </div>
//               <div className="col-md-2 pt-5 ">
//                 {/* <h5 style={{ color: "#FEBC11" }}>Column 4</h5> */}
//                 <p>Campus.</p>
//                 <p>Global Education</p>
//                 <p>Diverse & Inclusive Excellence</p>
//                 <p>Sustainability</p>
//                 <p>Accessbility</p>
//               </div>
//               <div className="col-md-2 pt-5 px-4">
//                 <p style={{ fontFamily: "bold" }}>kennesaw.edu/info</p>
//                 <div
//                   style={{
//                     height: 73,
//                     width: "100%",
//                     backgroundColor: "#202020",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   <img src={Logo} alt="" style={{ height: 73, width: 301 }} />
//                 </div>
//               </div>
//             </div>
//             <div className="row">
//               <div className="col-md-12 text-center">
//                 <p>
//                   &copy; 2023 Kennesaw State University. All Rights Reserved.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </footer>
//       </div>
//     </div>
//   );
// }

// export default App;







import {
  createBrowserRouter,
  RouterProvider
} from 'react-router-dom';

import { Navigate } from "react-router-dom";

/****Layouts*****/
import Home from "../src/components/home";
import Courses from "../src/components/courses";
import Resources from './components/resources';
import ALG from "./components/alg";
import CoOrdinator from "./components/co-ordinators";
import PremSchedules from "./components/prem-schedules";

const router = createBrowserRouter([
  { path: "/", element: <Navigate to="/home" /> },
  { path: "/home", exact: true, element: <Home /> },
  { path: "/courses", exact: true, element: <Courses /> },
  { path: "/resources", exact: true, element: <Resources /> },
  { path: "/alg", exact: true, element: <ALG /> },
  { path: "/co-ordinators", exact: true, element: <CoOrdinator /> },
  { path: "/prem-schedules", exact: true, element: <PremSchedules /> }
]);

const App = () => {
  return <div className="dark"><RouterProvider router={router} /></div>;
};

export default App;